const rules = {
  required: (v: any) => !!v || 'Ce champ est obligatoire',
  notEmpty: (v: any) => (v && v.length > 0) ? true : 'Veuillez choisir au moins une valeur',
  email: (v: any) => v && typeof v === 'string' && /^.+@\S+\.\S+$/.test(v) || 'Veuillez saisir un E-mail valide',
  strictLength: (len: number, err?: string) => (v: any) => (!v || v.length === len) ? true : (err || 'La longueur du champ saisie est invalide'),
  minLength: (len: number, err?: string) => (v: any) => (!v || v.length >= len) ? true : (err || `Vous devez saisir au moins ${len} caractère(s)`),
  maxLength: (len: number, err?: string) => (v: any) => (!v || v.length <= len) ? true : (err || `Vous devez saisir ${len} caractère(s) maximum`)
}

export default rules
